/**
 * Evaluates an expression when the element comes into view inside its nearest scrolling ancestor -
 * put it on a marker after a list for infinite scroll: when-visible="loadMore()".
 *
 * Unlike scrolled-to-bottom it does not fire on every scroll event, and it can fire ahead of the
 * end, so the next page is usually in before the reader gets there.
 *
 *   when-visible-margin  How far ahead of the visible edge to fire, as a CSS margin. Default 200px.
 *   when-visible-watch   An expression to watch, e.g. the list's length. An IntersectionObserver
 *                        only reports changes, so a page too short to push the marker out of view
 *                        would otherwise never load the next one; each change re-checks.
 *
 * Where IntersectionObserver is missing it does nothing, so keep a button that does the same.
 */
app.directive("whenVisible", [
	"$window",
	function ($window) {
		/** The element that scrolls the marker: an ancestor with its own overflow, else the page. */
		function scrollParent(el) {
			for (let parent = el.parentElement; parent; parent = parent.parentElement) {
				const overflowY = $window.getComputedStyle(parent).overflowY;
				if (overflowY === "auto" || overflowY === "scroll") {
					return parent;
				}
			}
			return null;
		}

		return {
			restrict: "A",
			link: function (scope, element, attrs) {
				if (!$window.IntersectionObserver) {
					return;
				}
				const el = element[0];
				const observer = new $window.IntersectionObserver(
					function (entries) {
						if (entries.some(entry => entry.isIntersecting)) {
							scope.$applyAsync(attrs.whenVisible);
						}
					},
					{ root: scrollParent(el), rootMargin: attrs.whenVisibleMargin || "200px" }
				);
				observer.observe(el);

				// Observing again reports the marker's current state, so it fires if still in view.
				if (attrs.whenVisibleWatch) {
					scope.$watch(attrs.whenVisibleWatch, function (value, previous) {
						if (value !== previous) {
							observer.unobserve(el);
							observer.observe(el);
						}
					});
				}

				scope.$on("$destroy", function () {
					observer.disconnect();
				});
			},
		};
	},
]);
